import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { StatusObj } from "../authSliceLogin/authSliceLogin";

export interface INotificationHistory {
  id: number;
  user_id: number;
  type_alert: string;
  application_id: number;
  content: string;
  status_id: number | null;
  data: StatusObj;
}

interface INotification {
  app_id: string | number;
  application?: { title?: string; status?: StatusObj };
  bank?: { title: string; status?: StatusObj };
  isNewMessage?: boolean;
}
interface IInitialState {
  ALL_NOTIFICATIONS: INotification[];
  COUNT_NOTIFICATIONS: number;
}

const initialState: IInitialState = {
  ALL_NOTIFICATIONS: [],
  COUNT_NOTIFICATIONS: 0,
};

// уведомления
const notificationsSlice = createSlice({
  name: "NOTIFICATIONS_SLICE",
  initialState: initialState,
  reducers: {
    // обновить все уведомления
    UP_DATE_NOTIFICATIONS_ALL: (
      state,
      actions: PayloadAction<INotificationHistory[]>
    ) => {
      if (actions.payload.length !== 0) {
        const notificationsHistory = actions.payload.filter(
          (item) => item.data
        );
        state.ALL_NOTIFICATIONS = notificationsHistory.map((notification) => {
          const { application_id, data, type_alert, content } = notification;

          if (data) {
            if (
              type_alert === "bank_custom" ||
              type_alert === "bank_statuses"
            ) {
              if (data.info) {
                return {
                  app_id: `${application_id}`,
                  bank: { title: content, status: data },
                };
              } else {
                return {
                  app_id: `${application_id}`,
                  bank: { title: data.title },
                };
              }
            } else if (type_alert === "message") {
              return {
                app_id: `${application_id}`,
                isNewMessage: true,
              };
            } else if (type_alert === "application_statuses") {
              if (data.info) {
                return {
                  app_id: `${application_id}`,
                  application: { status: data },
                };
              }
            } else if (type_alert === "message") {
              return {
                app_id: `${application_id}`,
                isNewMessage: true,
              };
            }
          }
          return {
            app_id: `${application_id}`,
            application: { title: content },
          };
        });

        state.COUNT_NOTIFICATIONS = notificationsHistory.length;
      }
    },
    // добавить новое уведомление в список
    ADD_APP_EVENT: (state, actions: PayloadAction<INotification>) => {
      state.ALL_NOTIFICATIONS.unshift(actions.payload);
      state.COUNT_NOTIFICATIONS += 1;
    },
    // обновить число уведомлений
    UP_DATE_NOTIFICATION_COUNT: (state, actions: PayloadAction<number>) => {
      state.COUNT_NOTIFICATIONS = actions.payload;
    },
    // удалить уведомление
    CLEARE_APP_NOTIFICATIONS: (
      state,
      actions: PayloadAction<{ app_id: number | string }>
    ) => {
      const updateNotifications = state.ALL_NOTIFICATIONS.filter(
        (notification: INotification) =>
          notification.app_id !== actions.payload.app_id
      );
      state.ALL_NOTIFICATIONS = updateNotifications;
      state.COUNT_NOTIFICATIONS = updateNotifications.length;
    },
  },
});

export const {
  ADD_APP_EVENT,
  UP_DATE_NOTIFICATIONS_ALL,
  UP_DATE_NOTIFICATION_COUNT,
  CLEARE_APP_NOTIFICATIONS,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
